import { Navigate, Outlet } from "react-router";
import { useAuthContext } from "../../contexts/AuthContext";

export const PublicRoute = ({ redirectPath = '/wallboard' }) => {
    const { userData } = useAuthContext();

    if (userData) {
        return <Navigate to={redirectPath} replace />;
    }

    return <Outlet />
}